<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ "museums.search-title" | translate }}</h2>

<mat-dialog-content>
  <loading-spinner></loading-spinner>
  <form [formGroup]="searchForm" class="standard-form">
    <div class="grid-container">
      <!-- Name Field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ "museums.museum-name" | translate }}</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <!-- Evaneos Code Field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ "hotels.evaneos-code" | translate }}</mat-label>
        <input matInput formControlName="evaneosCode" />
      </mat-form-field>

      <!-- Region Field -->
      <region-select formControlName="region"></region-select>

      <!-- Nation -->
      <country-select formControlName="nation"></country-select>

    </div>
  </form>

  <mat-divider></mat-divider>

  <!-- Search result Data Table -->
  <table
    mat-table
    [dataSource]="(dataSource$ | async) ?? []"
    matSort
    class="standard-datatable mat-elevation-z8"
  >
    <!-- Museum Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "museums.museum-name" | translate }}
      </th>
      <td mat-cell *matCellDef="let museum">{{ museum.name }}</td>
    </ng-container>

    <!-- Region Column -->
    <ng-container matColumnDef="region">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "region.title" | translate }}
      </th>
      <td mat-cell *matCellDef="let museum">{{ museum.region }}</td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let museum" class="action-column">
          <button mat-raised-button color="primary" (click)="pickMuseum(museum)">
            <mat-icon>subdirectory_arrow_right</mat-icon>
            {{ "pick" | translate }}
          </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button id="clear-filter-button" mat-stroked-button color="warn" (click)="onClearFilter()">
    <mat-icon>clear</mat-icon>
    {{ "clear-filter" | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="onSearch()">
    <mat-icon>search</mat-icon>
    {{ "search-title" | translate }}
  </button>
</mat-dialog-actions>
